import {
  parseUri,
} from './common';

let multiStr = 'mefmultiparams'
function checkMulti(path){
  let index = path.indexOf(multiStr)
  if(index!=-1){
    return path.substring(0,index-1)
  }
  return path
}

export function checkPath(path) {
  let pathname = location.pathname.toLocaleLowerCase();
  pathname = checkMulti(pathname)
  path = path.toLocaleLowerCase();

  if (pathname === path) {
    if (!window.__isPadPage && window.__GetFrameDataByKey) {//检查菜单
      const menus = window.__GetFrameDataByKey('menu')[3];
      if (menus) {
        for (const k in menus) {
          const uri = parseUri(menus[k].n_href);
          let mpath = checkMulti(uri.path.toLocaleLowerCase())
          if (mpath === path) {
            return true;
          }
        }
      }
      return false;
    }
    return true;
  }
  return false;
}
export function treePath(apps) {
  const treeAttr = {};
  let path; let hadSub;
  for (const app of apps) {
    path = app.path.toLocaleLowerCase();
    hadSub = false;
    for (const a2 of apps) {
      const subPath = a2.path.toLocaleLowerCase();
      if (path != subPath && subPath.startsWith(path)) {
        hadSub = true;
        break;
      }
    }
    treeAttr[path] = hadSub;
  }
  return treeAttr;
}
